let timer = null

function throttle(fn, delay) {
  return function () {
    if (timer) {
      return
    }
    fn.apply(this, arguments)
    timer = setTimeout(() => {
      timer = null
    }, delay)
  }
}

function setHalfSpacing() {
  const root = document.documentElement;
  const wrapper = document.querySelector('.t4s-container');
  if (!wrapper) return;

  const wrapperWidth = wrapper.offsetWidth;
  const usableWidth = document.documentElement.clientWidth;
  const result = Math.max((usableWidth - wrapperWidth) / 2, 0);

  root.style.setProperty('--half-spacing', result + 'px');
}

setHalfSpacing();

window.addEventListener('resize', setHalfSpacing);

document.addEventListener('shopify:section:load', setHalfSpacing);
document.addEventListener('shopify:section:reorder', setHalfSpacing);
document.addEventListener('shopify:section:unload', setHalfSpacing);

function initHover(el) {
  if (el.__hoverInited) return;

  el.__hoverInited = true;

  const hoverItem = el.querySelectorAll('.hover-video-item');

  let timer = null;

  hoverItem.forEach(item => {
    item.addEventListener('mouseenter', () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        hoverItem.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
      }, 120);
    });
  });
};

async function initSlider(el) {
  if (el.__slider) return;

  el.__slider = true;

  const itemWrap = el.querySelector('.slider-wrapper');
  const itemChildItem = el.querySelectorAll('.slider-list-item');
  const itemContentItem = el.querySelectorAll('.slider-list-content-item');
  const itemControl = el.querySelectorAll('.slider-control a');
  if (!itemWrap) return;

  let length = el.getAttribute('data-length');
  let index = length && Number(length) > 0 ? Number(length) : itemWrap.children.length / 3;
  let step = index;
  let startX = 0;
  let currentX = 0;
  let isDragging = false; 0

  // 是否有active
  const hasActive = el.hasAttribute('data-active');
  // 是否有video
  const hasVideo = el.querySelectorAll('video').length > 0;
  // 自动获取高度
  const hasAutoheight = el.hasAttribute('data-autoheight');
  // 自动播放
  const hasAutoplay = el.hasAttribute('data-autoplay');

  let autoplayTimer = null;
  let autoplayDelay = 3000;
  let isHovering = false;

  /* 延迟真实宽度 */
  function getItemValue() {
    return new Promise(resolve => {
      let frame = 0;

      function check() {
        frame++;

        if (frame > 10) {
          const itemWidth = el.querySelector('.slider-list-item').getBoundingClientRect().width;
          const itemSpace = el.hasAttribute('data-center') ? (el.getBoundingClientRect().width - itemWidth) / 2 : 0;
          const itemActiveHeight = el.querySelector('.slider-list-item.active')?.getBoundingClientRect().height;

          resolve({
            itemActiveHeight,
            itemWidth,
            itemSpace
          });
        } else {
          requestAnimationFrame(check);
        }
      }

      requestAnimationFrame(check);
    });
  }

  /* 初次获取真实宽度 */
  let {
    itemActiveHeight,
    itemWidth,
    itemSpace
  } = await getItemValue();

  window.addEventListener('resize', async () => {
    ({
      itemActiveHeight,
      itemWidth,
      itemSpace
    } = await getItemValue());
    if (hasAutoheight) {
      getHeight();
    }
    resetPosition();
  });

  setTranslate();

  if (hasAutoheight) {
    getHeight();
  }

  if (hasAutoplay) {
    startAutoplay();
  }

  /* 左右箭头控制 */
  itemControl.forEach((item, i) => {
    if (i == 0) {
      item.addEventListener('click', throttle(function () {
        isDragging = true;
        onDragEnd('left', itemWrap, itemWidth, itemSpace);
      }, 300))
    } else if (i == '1') {
      item.addEventListener('click', throttle(function () {
        isDragging = true;
        onDragEnd('right', itemWrap, itemWidth, itemSpace);
      }, 300))
    }
  })

  // Mouse events
  itemWrap.addEventListener('mouseenter', function (e) {
    if (!hasAutoplay) return;

    isHovering = true;
    stopAutoplay();
  });

  itemWrap.addEventListener('mousedown', function (e) {
    onDragStart(e);
  });

  itemWrap.addEventListener('mousemove', function (e) {
    onDragMove(e)
  });

  itemWrap.addEventListener('mouseup', function (e) {
    onDragEnd(false);
  });

  itemWrap.addEventListener('mouseleave', function (e) {
    onDragEnd(false);

    if (!hasAutoplay) return;

    isHovering = false;
    startAutoplay();
  });

  // Touch events (mobile support optional)
  let touchMoved = false;

  itemWrap.addEventListener('touchstart', function (e) {
    touchMoved = false;
    onDragStart(e);
  }, {
    passive: true
  });

  itemWrap.addEventListener('touchmove', function (e) {
    touchMoved = true;
    onDragMove(e);
  }, {
    passive: true
  });

  itemWrap.addEventListener('touchend', function (e) {
    if (!touchMoved) return;
    onDragEnd(false);
  }, {
    passive: true
  });

  function toggleActive(list, activeIndex) {
    if (!list || list.length === 0) return;

    list.forEach((item, ind) => {
      item.classList.toggle('active', ind === activeIndex);
    });
  }

  function handleVideo(activeIndex) {
    itemChildItem.forEach((item, i) => {
      const video = item.querySelector('video');

      // 当前 slide 没有 video
      if (!video) return;

      // 当前 active
      if (i === activeIndex) {
        video.play().catch(() => { });
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function getHeight() {
    el.style.height = itemActiveHeight + 'px';
  }

  function startAutoplay() {
    if (!hasAutoplay) return;

    stopAutoplay();

    autoplayTimer = setInterval(() => {
      if (isDragging || isHovering) return;

      index++;
      resetPosition();
    }, autoplayDelay);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function setTranslate() {
    itemWrap.style.transition = 'none';
    itemWrap.style.transform = `translate3d(-${index * itemWidth - itemSpace}px, 0, 0)`;

    if (hasActive) {
      toggleActive(itemChildItem, index);
      toggleActive(itemContentItem, index - step);
    }

    if (hasVideo) {
      handleVideo(index);
    }
  }

  function resetPosition(delta) {
    itemWrap.style.transition = 'transform 0.25s ease';
    itemWrap.style.transform = `translate3d(-${index * itemWidth - itemSpace}px, 0, 0)`;

    if (index <= step - 1) {
      index = itemWrap.children.length - (step * 2) + index;
    } else if (index >= itemWrap.children.length - step) {
      index = index - (itemWrap.children.length - (step * 2));
    }

    if (hasActive && (delta == null || Math.abs(delta) > 50)) {
      itemChildItem.forEach(item => {
        item.classList.remove('active');

        const video = item.querySelector('video');

        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    }

    setTimeout(() => {
      setTranslate();
    }, 200);
  }

  let moved = false;

  function onDragStart(e) {
    e.preventDefault();

    moved = false;
    isDragging = true;

    if (hasAutoplay) stopAutoplay();

    startX = e.pageX || e.touches[0].pageX;
    currentX = startX;
    itemWrap.style.transition = 'none';
  }

  function onDragMove(e) {
    if (!isDragging) return;

    currentX = e.pageX || e.touches[0].pageX;

    const delta = currentX - startX;

    if (Math.abs(delta) > 5) {
      moved = true;
    }

    itemWrap.style.transform = `translate3d(-${index * itemWidth - itemSpace - delta}px, 0, 0)`;
  }

  function onDragEnd(direction) {
    if (!isDragging) return;

    let delta = null;

    if (!direction) {
      delta = currentX - startX;
      let result = delta / itemWidth;
      result = result > 0 ? Math.ceil(result) : Math.floor(result);

      if (delta < -50 && delta >= -(itemWidth)) {
        index++;
      } else if (delta > 50 && delta <= itemWidth) {
        index--;
      } else if (delta < -(itemWidth)) {
        index += Math.abs(result)
      } else if (delta > itemWidth) {
        index -= Math.abs(result)
      }
    } else {
      if (direction === 'left') {
        index--;
      } else if (direction === 'right') {
        index++;
      }
    }

    resetPosition(delta);
    isDragging = false;

    if (hasAutoplay) startAutoplay();
  }

  itemWrap.addEventListener('click', function (e) {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
};

const watchList = [
  {
    selector: '.hover-video',
    handler: initHover,
    flag: '__hoverInited'
  },
  {
    selector: '.slider-list',
    handler: initSlider,
    flag: '__slider'
  }
];

// 初次加载
watchList.forEach(item => {
  document.querySelectorAll(item.selector).forEach(node => {
    if (item.flag && node[item.flag]) return;
    item.handler(node);
  });
});

// 统一 MutationObserver 监听
let moTimer = null;

const observer = new MutationObserver(() => {
  clearTimeout(moTimer);
  moTimer = setTimeout(() => {
    watchList.forEach(item => {
      document.querySelectorAll(item.selector).forEach(node => {
        if (item.flag && node[item.flag]) return;
        item.handler(node);
      });
    });
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});